__turbopack_context__.v({
  "admin-bg-danger": "Testimonials-module-scss-module__3Kwsgq__admin-bg-danger",
  "admin-bg-info": "Testimonials-module-scss-module__3Kwsgq__admin-bg-info",
  "admin-bg-primary": "Testimonials-module-scss-module__3Kwsgq__admin-bg-primary",
  "admin-bg-secondary": "Testimonials-module-scss-module__3Kwsgq__admin-bg-secondary",
  "admin-bg-success": "Testimonials-module-scss-module__3Kwsgq__admin-bg-success",
  "admin-bg-warning": "Testimonials-module-scss-module__3Kwsgq__admin-bg-warning",
  "admin-border": "Testimonials-module-scss-module__3Kwsgq__admin-border",
  "admin-border-dark": "Testimonials-module-scss-module__3Kwsgq__admin-border-dark",
  "admin-border-light": "Testimonials-module-scss-module__3Kwsgq__admin-border-light",
  "admin-rounded": "Testimonials-module-scss-module__3Kwsgq__admin-rounded",
  "admin-rounded-full": "Testimonials-module-scss-module__3Kwsgq__admin-rounded-full",
  "admin-rounded-lg": "Testimonials-module-scss-module__3Kwsgq__admin-rounded-lg",
  "admin-rounded-md": "Testimonials-module-scss-module__3Kwsgq__admin-rounded-md",
  "admin-rounded-sm": "Testimonials-module-scss-module__3Kwsgq__admin-rounded-sm",
  "admin-shadow-lg": "Testimonials-module-scss-module__3Kwsgq__admin-shadow-lg",
  "admin-shadow-md": "Testimonials-module-scss-module__3Kwsgq__admin-shadow-md",
  "admin-shadow-sm": "Testimonials-module-scss-module__3Kwsgq__admin-shadow-sm",
  "admin-sr-only": "Testimonials-module-scss-module__3Kwsgq__admin-sr-only",
  "admin-text-light": "Testimonials-module-scss-module__3Kwsgq__admin-text-light",
  "admin-text-muted": "Testimonials-module-scss-module__3Kwsgq__admin-text-muted",
  "admin-text-primary": "Testimonials-module-scss-module__3Kwsgq__admin-text-primary",
  "admin-text-secondary": "Testimonials-module-scss-module__3Kwsgq__admin-text-secondary",
  "testimonials": "Testimonials-module-scss-module__3Kwsgq__testimonials",
  "testimonials__client": "Testimonials-module-scss-module__3Kwsgq__testimonials__client",
  "testimonials__container": "Testimonials-module-scss-module__3Kwsgq__testimonials__container",
  "testimonials__container--no-bottom": "Testimonials-module-scss-module__3Kwsgq__testimonials__container--no-bottom",
  "testimonials__container--no-top": "Testimonials-module-scss-module__3Kwsgq__testimonials__container--no-top",
  "testimonials__container--no-vertical": "Testimonials-module-scss-module__3Kwsgq__testimonials__container--no-vertical",
  "testimonials__grid": "Testimonials-module-scss-module__3Kwsgq__testimonials__grid",
  "testimonials__item": "Testimonials-module-scss-module__3Kwsgq__testimonials__item",
  "testimonials__quote": "Testimonials-module-scss-module__3Kwsgq__testimonials__quote",
  "testimonials__title": "Testimonials-module-scss-module__3Kwsgq__testimonials__title",
});
